module.exports = __webpack_public_path__ + "img/swordsman.e6b5a1ac.png";